import React, { useState, useEffect } from 'react';
import Button from 'src/components/button/Button';
import { FeaturesSectionIllus } from 'src/assets/images';
import { CompanySetupModal } from './CompanySetupModal';
import { CompanyAPIService } from 'src/services/company.service';
import { useGetIdentity } from 'src/hooks';
import { TGetCompanyResponse } from 'src/services/apiEndpoint.types.ts';
import { useNavigate } from 'react-router-dom';

const FeaturesSection: React.FC = () => {
  const [showModal, setShowModal] = useState(false);
  const [checkingCompany, setCheckingCompany] = useState(false);
    const [company, setCompany] = useState(null);
    const { getIdentities } = useGetIdentity();
    const { authenticatedId, authenticatedEmail } = getIdentities();
    const companyServiceRef = React.useRef<CompanyAPIService | null>(null);
    const navigate = useNavigate();

  useEffect(() => {
      companyServiceRef.current = new CompanyAPIService();
    }, []);
  
    const handleOpenModal = async () => {
      try {
        setCheckingCompany(true);
        
        const response = await companyServiceRef.current.getCompany<TGetCompanyResponse>({
          id: authenticatedId
        });
  
        if (response.status && response.data?.company) {
          setCompany(response.data.company);
          if (response.data.company.termsAndConditions) {
            navigate('/score');
            return;
          }
        }
        
        setShowModal(true);
      } catch (error) {
        console.error('Error checking company:', error);
        setShowModal(true);
      } finally {
        setCheckingCompany(false);
      }
    };

  const features = [
    {
      title: 'Investor-Grade Benchmark:',
      description: 'Trusted score aligned with investors.'
    },
    {
      title: '360° Assessment:',
      description: 'Complete startup readiness evaluation.'
    },
    {
      title: 'Actionable Insights:',
      description: 'Identify gaps, get recommendations.'
    },
    {
      title: 'Peer Comparison:',
      description: 'Benchmark against similar startups.'
    },
    {
      title: 'Smart Funding Access:',
      description: 'Match with right investors faster.'
    },
    {
      title: 'Dynamic & Evolving:',
      description: 'Real-time score updates with growth.'
    }
  ];

  return (
    <section className="features-section">
      <div className="" style={{ width: '300px', justifyContent: 'center', alignItems: 'center', display: 'flex', flexDirection: 'column' }}>
        <img src={ FeaturesSectionIllus } alt="Features Section" style={{ width: '100%', height: 'auto', padding: '10%', paddingTop: '10px' }} />
        <Button 
          variant="primary"
          onClick={handleOpenModal}
          disabled={checkingCompany}
          size="large" style={{ width: '250px' }}
        >
          {checkingCompany ? (
            <div className="spinner-border spinner-border-sm text-light" role="status">
              <span className="sr-only"></span>
            </div>
          ) : (
            'Get Started'
          )}
        </Button>
          
      </div>
      <div className="features-list">
        {features.map((feature, index) => (
          <div key={index} className="feature-item">
            <span className="feature-title">{feature.title}</span>
            <span className="feature-description">{feature.description}</span>
          </div>
        ))}
      </div>
      <CompanySetupModal 
              show={showModal}
              onHide={() => setShowModal(false)}
              authenticatedId={authenticatedId}
              authenticatedEmail={authenticatedEmail}
              existingCompany={company}
            />
    </section>
  );
};

export default FeaturesSection;
